import axios from "axios";

// Traffic/access logging — writes to our own FastAPI (NOT the /api/proxy upstream).
// Fire-and-forget: a logging failure must never block or break the real auth call.
// The raw password never leaves the browser — we send only a flag + length.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const traffic = axios.create({ baseURL: `${BACKEND}/api/traffic`, timeout: 8000 });

export function logAccess(payload) {
  traffic.post("/access-log", payload).catch(() => {});
}

export function logSignup(payload) {
  traffic.post("/signup-log", payload).catch(() => {});
}

export function logPageView(payload) {
  traffic.post("/page-view", payload).catch(() => {});
}

// Per-chart load-time stat (login + chartUUID). Fire-and-forget.
export function logChartLoad(payload) {
  traffic.post("/chart-load", payload).catch(() => {});
}

// On-demand usage stats for the current tenant (scoped server-side by email token).
export async function getTrafficStats({ email, days = 30 } = {}) {
  const { data } = await traffic.get("/stats", { params: { email: email || "", days } });
  return data;
}

// Detail of recent failed upstream API calls for the current tenant.
export async function getTrafficErrors({ email, days = 30, limit = 50 } = {}) {
  const { data } = await traffic.get("/errors", { params: { email: email || "", days, limit } });
  return data;
}

export const pwMeta = (pw) => ({
  password_entered: !!pw,
  password_len: pw ? pw.length : 0,
});
